import { Navigate } from 'react-router-dom';
import { useAppStore } from '../../stores/appStore';

interface AdminRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard for admin-only pages. Assumes it is nested inside a
 * `ProtectedRoute` (which already handles the unauthenticated + Pending cases),
 * so here we only additionally require the `Admin` role. A non-admin who reaches
 * an admin URL — via a stale nav item or by typing the path directly — is sent
 * back to the dashboard rather than rendering a page whose API calls will 401/403.
 *
 * This is defense-in-depth only: the backend remains the real authority and
 * rejects non-admin callers regardless of what the UI renders.
 */
export default function AdminRoute({ children }: AdminRouteProps) {
  const currentUser = useAppStore((state) => state.currentUser);

  if (currentUser?.role !== 'Admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
